import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=7841a620&scoped=true&"
import script from "./CouponDetail.vue?vue&type=script&lang=ts&"
export * from "./CouponDetail.vue?vue&type=script&lang=ts&"
import style1 from "./CouponDetail.vue?vue&type=style&index=1&id=7841a620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841a620",
  null
  
)

export default component.exports